var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
export const alarmNotificationsApi = {
    getAlarmNotifications: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const queryParams = new URLSearchParams();
        if (params === null || params === void 0 ? void 0 : params.accessPointUid) {
            queryParams.append("accessPointUid", params.accessPointUid);
        }
        if (params === null || params === void 0 ? void 0 : params.nodeUid) {
            queryParams.append("nodeUid", params.nodeUid);
        }
        if ((params === null || params === void 0 ? void 0 : params.isAcknowledged) !== undefined) {
            queryParams.append("isAcknowledged", params.isAcknowledged.toString());
        }
        if ((params === null || params === void 0 ? void 0 : params.acknowledgedBy) && params.acknowledgedBy.length > 0) {
            params.acknowledgedBy.forEach((id) => {
                queryParams.append("acknowledgedBy", id);
            });
        }
        if ((params === null || params === void 0 ? void 0 : params.alarmTypes) && params.alarmTypes.length > 0) {
            params.alarmTypes.forEach((type) => {
                queryParams.append("alarmTypes", type.toString());
            });
        }
        if (params === null || params === void 0 ? void 0 : params.search) {
            queryParams.append("search", params.search);
        }
        if (params === null || params === void 0 ? void 0 : params.pageNumber) {
            queryParams.append("pageNumber", params.pageNumber.toString());
        }
        if (params === null || params === void 0 ? void 0 : params.pageSize) {
            queryParams.append("pageSize", params.pageSize.toString());
        }
        const queryString = queryParams.toString();
        const url = `/alarm-notifications${queryString ? `?${queryString}` : ""}`;
        const response = yield siteX.get(url);
        return response.data;
    }),
    getAlarmById: (alarmId) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.get(`alarm-notifications/${alarmId}`);
        return response.data;
    }),
    acknowledgeAlarm: (alarmId, request) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post(`alarm-notifications/${alarmId}/acknowledge`, request || {});
        return response.data;
    }),
    acknowledgeAllAlarms: (request) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("alarm-notifications/acknowledge-all", request || {});
        return response.data;
    }),
    editAcknowledgedAlarm: (alarmId, request) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.put(`alarm-notifications/${alarmId}/edit`, request || {});
        return response.data;
    }),
    getAlarmCausesDropdown: () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.get("AlarmCauses/dropdown");
        return response.data;
    }),
};
